/* ============================================================
   Summit Animal Health — Labor Day sale landing page
   Shared behaviour for every sah-ld-* section.
   Everything is namespaced under .sld-* so nothing here can
   collide with the rest of the theme.
   ============================================================ */
(function () {
  'use strict';

  /* Several sections each request this file, so the tag can execute more than
     once on a page. Bind only the first time through. */
  if (window.__sldInit) return;
  window.__sldInit = true;

  function money(n) { return '$' + n.toFixed(2); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---------- buy boxes: size pills, thumbnails, quantity, add to cart ---------- */
  function initCard(card) {
    if (card.dataset.sldReady) return;
    card.dataset.sldReady = '1';

    var sizes = card.querySelectorAll('.sld-size');
    var img = card.querySelector('[data-sld-img]');
    /* Target the price row by CLASS, not by [data-was] and friends: the size
       pills carry those same attributes as their data source and sit earlier
       in the card, so an attribute lookup grabs a pill and writes the price
       into its label. */
    var was = card.querySelector('.sld-price__was');
    var now = card.querySelector('.sld-price__now');
    var save = card.querySelector('.sld-price__save');
    var day = card.querySelector('.sld-price__day');
    var addBtn = card.querySelector('[data-sld-add]');
    var box = card.querySelector('[data-sld-qty]');
    var input = box ? box.querySelector('input') : null;
    var dec = box ? box.querySelector('[data-sld-dec]') : null;
    var inc = box ? box.querySelector('[data-sld-inc]') : null;

    function refresh() {
      if (!input) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 1) q = 1;
      if (q > 99) q = 99;
      input.value = q;
      if (dec) dec.disabled = q <= 1;
      if (inc) inc.disabled = q >= 99;

      var u = parseFloat(card.dataset.unit || '0');
      if (addBtn && !addBtn.dataset.sldBusy) {
        addBtn.textContent = u > 0
          ? 'Add ' + (q > 1 ? q + ' ' : '') + 'to cart · ' + money(u * q)
          : (q > 1 ? 'Add ' + q + ' to cart' : 'Add to cart');
      }
    }

    if (dec) dec.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) - 1; refresh(); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; refresh(); });
    if (input) { input.addEventListener('change', refresh); input.addEventListener('input', refresh); }

    /* thumbnail rail: click swaps the main pane */
    var thumbs = card.querySelectorAll('[data-sld-thumb]');
    var prodThumb = card.querySelector('[data-sld-role="product"]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.classList.remove('sld-is-on'); });
        t.classList.add('sld-is-on');
        if (img) img.src = t.dataset.src;
      });
    });

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizes.forEach(function (b) { b.classList.remove('sld-is-on'); });
        btn.classList.add('sld-is-on');
        if (!btn.dataset.now) return;
        card.dataset.unit = btn.dataset.now;
        card.dataset.variant = btn.dataset.variant || '';
        /* a size with no variant yet (300-day before the SKU exists) can show
           its price but must not offer a dead add-to-cart */
        if (addBtn && !addBtn.dataset.sldBusy) addBtn.disabled = !card.dataset.variant;
        if (was) was.textContent = '$' + btn.dataset.was;
        if (now) now.textContent = '$' + btn.dataset.now;
        if (save) save.textContent = 'Save $' + btn.dataset.save;
        if (day) day.textContent = '$' + btn.dataset.day + ' per day';
        if (btn.dataset.src) {
          /* the product thumb tracks the chosen size; only repaint the main
             pane if the shopper is actually looking at the product shot */
          if (prodThumb) {
            prodThumb.dataset.src = btn.dataset.src;
            var pi = prodThumb.querySelector('img');
            if (pi) pi.src = btn.dataset.src;
          }
          if (img && (!prodThumb || prodThumb.classList.contains('sld-is-on'))) img.src = btn.dataset.src;
        }
        refresh();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = card.dataset.variant;
        if (!variantId) return;
        var qty = input ? (parseInt(input.value, 10) || 1) : 1;
        var original = addBtn.textContent;
        addBtn.dataset.sldBusy = '1';
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            addBtn.disabled = false;
            if (d && d.status) {
              /* inline error state — never an alert(), which would block the page */
              var msg = d.description || 'Could not add to cart';
              addBtn.textContent = msg.length > 40 ? 'Could not add to cart' : msg;
              setTimeout(function () { delete addBtn.dataset.sldBusy; addBtn.textContent = original; }, 3200);
              return;
            }
            delete addBtn.dataset.sldBusy;
            addBtn.textContent = original;
            /* the drawer shows full price (no code field on this store), so
               leave a reminder in the card that the code goes in at checkout */
            var added = card.querySelector('[data-sld-added]');
            if (added) added.hidden = false;
            /* the theme's cart drawer listens for its own events; a plain
               cart/add.js does not always open it, so nudge both the common
               hooks and fall back to leaving the shopper where they are */
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            var opener = document.querySelector('[data-sld-cart-open]');
            if (opener) opener.click();
          })
          .catch(function () {
            addBtn.disabled = false;
            delete addBtn.dataset.sldBusy;
            addBtn.textContent = original;
          });
      });
    }

    refresh();
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    root.querySelectorAll('.sld-faq__q').forEach(function (q) {
      if (q.dataset.sldReady) return;
      q.dataset.sldReady = '1';
      q.addEventListener('click', function () { q.parentElement.classList.toggle('sld-is-open'); });
    });
  }

  /* ---------- countdown ----------
     One target only: the moment the sale closes. Never counts down to the
     opening — a shopper only cares how long is left to buy. The target is
     read off the element, so it is editable in the theme editor. */
  function initCountdown(el) {
    if (el.dataset.sldReady) return;
    el.dataset.sldReady = '1';
    var end = Date.parse(el.dataset.sldEnd);
    if (isNaN(end)) return;
    var compact = el.hasAttribute('data-sld-compact');
    var D = el.querySelector('[data-sld-d]'), H = el.querySelector('[data-sld-h]'),
      M = el.querySelector('[data-sld-m]'), S = el.querySelector('[data-sld-s]');
    var endedText = el.dataset.sldEnded || 'This sale has ended';
    var labelText = el.dataset.sldLabel || 'Sale ends in';

    function tick() {
      var t = Date.now();
      if (t >= end) {
        if (compact) el.textContent = endedText;
        else if (D) { D.textContent = H.textContent = M.textContent = S.textContent = '00'; }
        clearInterval(timer);
        return;
      }
      var d = end - t;
      var dd = Math.floor(d / 86400000), hh = Math.floor(d % 86400000 / 3600000),
        mm = Math.floor(d % 3600000 / 60000), ss = Math.floor(d % 60000 / 1000);
      if (compact) el.textContent = labelText + ' ' + dd + 'd ' + pad(hh) + 'h ' + pad(mm) + 'm';
      else if (D) { D.textContent = pad(dd); H.textContent = pad(hh); M.textContent = pad(mm); S.textContent = pad(ss); }
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ---------- sticky mobile buy bar ---------- */
  function initSticky(bar) {
    if (bar.dataset.sldReady) return;
    bar.dataset.sldReady = '1';
    var hero = document.querySelector('.sld-hero');
    if (!hero || !('IntersectionObserver' in window)) { bar.classList.add('sld-is-on'); return; }
    /* keep a reference: a bare new IntersectionObserver(...).observe() is
       garbage collected and silently stops firing */
    bar.__sldIO = new IntersectionObserver(function (es) {
      bar.classList.toggle('sld-is-on', !es[0].isIntersecting);
    }, { threshold: 0 });
    bar.__sldIO.observe(hero);
  }

  /* ---------- in-page anchors ----------
     Was a global `html{scroll-behavior:smooth}` in the stylesheet, which
     applied to every page on the store. Handled here instead, scoped to this
     page's own #sld-* links, and offset by the theme's fixed header so the
     target heading does not land underneath it. */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.sld-page a[href^="#sld-"]') : null;
      if (!a) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.main-header-wrapper');
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 8;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  /* ---------- discount code chip: tap to copy ----------
     Delegated so chips rendered by any section (or re-rendered by the theme
     editor) work without re-binding. Clipboard API first, execCommand as the
     fallback for older Safari. */
  function initCodeChips() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.sld-code[data-sld-code]') : null;
      if (!chip) return;
      var code = chip.dataset.sldCode;
      var cp = chip.querySelector('.sld-code__cp');
      function done() {
        chip.classList.add('sld-is-copied');
        if (cp) cp.textContent = 'Copied';
        setTimeout(function () { chip.classList.remove('sld-is-copied'); if (cp) cp.textContent = 'Copy'; }, 2200);
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { if (document.execCommand('copy')) done(); } catch (x) { /* nothing to do */ }
        document.body.removeChild(ta);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else {
        fallback();
      }
    });
  }

  function boot(root) {
    root = root || document;
    root.querySelectorAll('.sld-pcard, .sld-buybox').forEach(initCard);
    root.querySelectorAll('.sld-faq').forEach(initFaq);
    root.querySelectorAll('[data-sld-countdown]').forEach(initCountdown);
    root.querySelectorAll('.sld-stickybuy').forEach(initSticky);
  }

  initAnchors();
  initCodeChips();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* theme editor re-renders a section in place — re-bind inside it */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
